var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLockedFill = function SvgLockedFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6c0-1.103.897-2 2-2s2 .897 2 2v2H8V6zm6.5 2H13V6c0-1.654-1.346-3-3-3S7 4.346 7 6v2H5.5C4.673 8 4 8.672 4 9.5v6c0 .827.673 1.5 1.5 1.5h9c.827 0 1.5-.673 1.5-1.5v-6c0-.828-.673-1.5-1.5-1.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgLockedFill;